import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {SEARCH_WIDGET} from "../search-widget-consts";

export class SearchWidgetToggleExpandedHandler extends ActionHandler {
  type = SEARCH_WIDGET.ACTION_TYPES.toggleExpandedHandler;

  async action(params) {
    const group = this.state.groupedResults.find(item => item.id === params.id);

    group.isExpanded = !group.isExpanded

    return params;
  }
}
